import type { SerializedStyles } from '@emotion/react';
import { css } from '@emotion/react';
import type { EmotionScore } from '@hotjar/insights-common/constants/emotions';
import { EMOTION_COLORS } from '@hotjar/insights-common/constants/emotions';

export function getIconColor(score: EmotionScore): string {
  return EMOTION_COLORS[score] ?? '';
}

export const iconSizeMap = {
  xs: 12,
  s: 18,
  m: 24,
  l: 40,
} as const;

export type IconSize = keyof typeof iconSizeMap;

export const iconBaseStyles = css`
  display: inline-block;
  vertical-align: middle;
`;

export const imageIconBaseStyles = (props: { size: number }): SerializedStyles => css`
  ${iconBaseStyles}
  width: ${props.size}px;
  height: ${props.size}px;
  background-size: ${props.size}px;
  background-repeat: no-repeat;
`;
